import React, { useState, createContext, useContext } from 'react';
interface NavigationContextType {
  currentPath: string;
  navigate: (path: string) => void;
}
const NavigationContext = createContext<NavigationContextType | undefined>(undefined);
export function NavigationProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [currentPath, setCurrentPath] = useState('/');
  const navigate = (path: string) => {
    setCurrentPath(path);
  };
  return <NavigationContext.Provider value={{
    currentPath,
    navigate
  }} data-id="element-2203">
      {children}
    </NavigationContext.Provider>;
}
export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}